"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMIME = exports.isHTTPCode = exports.isHTTPMethod = exports.MIMEs = exports.HTTPCodes = exports.HTTPHeaders = exports.HTTPMethods = void 0;
var HTTPMethods;
(function (HTTPMethods) {
    HTTPMethods["GET"] = "GET";
    HTTPMethods["HEAD"] = "HEAD";
    HTTPMethods["POST"] = "POST";
    HTTPMethods["PUT"] = "PUT";
    HTTPMethods["DELETE"] = "DELETE";
})(HTTPMethods = exports.HTTPMethods || (exports.HTTPMethods = {}));
var HTTPHeaders;
(function (HTTPHeaders) {
    HTTPHeaders["Accept"] = "Accept";
    HTTPHeaders["ContentType"] = "Content-Type";
})(HTTPHeaders = exports.HTTPHeaders || (exports.HTTPHeaders = {}));
var HTTPCodes;
(function (HTTPCodes) {
    HTTPCodes[HTTPCodes["OK"] = 200] = "OK";
    HTTPCodes[HTTPCodes["Created"] = 201] = "Created";
    HTTPCodes[HTTPCodes["Accepted"] = 202] = "Accepted";
    HTTPCodes[HTTPCodes["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HTTPCodes[HTTPCodes["NoContent"] = 204] = "NoContent";
    HTTPCodes[HTTPCodes["ResetContent"] = 205] = "ResetContent";
    HTTPCodes[HTTPCodes["PartialContent"] = 206] = "PartialContent";
    HTTPCodes[HTTPCodes["MultiStatus"] = 207] = "MultiStatus";
    HTTPCodes[HTTPCodes["AlreadyReported"] = 208] = "AlreadyReported";
    HTTPCodes[HTTPCodes["MultipleChoices"] = 300] = "MultipleChoices";
    HTTPCodes[HTTPCodes["MovedPermanently"] = 301] = "MovedPermanently";
    HTTPCodes[HTTPCodes["FoundOrMovedTemporarily"] = 302] = "FoundOrMovedTemporarily";
    HTTPCodes[HTTPCodes["SeeOther"] = 303] = "SeeOther";
    HTTPCodes[HTTPCodes["NotModified"] = 304] = "NotModified";
    HTTPCodes[HTTPCodes["UseProxy"] = 305] = "UseProxy";
    HTTPCodes[HTTPCodes["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HTTPCodes[HTTPCodes["PermanentRedirect"] = 308] = "PermanentRedirect";
    HTTPCodes[HTTPCodes["BadRequest"] = 400] = "BadRequest";
    HTTPCodes[HTTPCodes["Unauthorized"] = 401] = "Unauthorized";
    HTTPCodes[HTTPCodes["PaymentRequired"] = 402] = "PaymentRequired";
    HTTPCodes[HTTPCodes["Forbidden"] = 403] = "Forbidden";
    HTTPCodes[HTTPCodes["NotFound"] = 404] = "NotFound";
    HTTPCodes[HTTPCodes["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HTTPCodes[HTTPCodes["NotAcceptable"] = 406] = "NotAcceptable";
    HTTPCodes[HTTPCodes["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HTTPCodes[HTTPCodes["RequestTimeout"] = 408] = "RequestTimeout";
    HTTPCodes[HTTPCodes["Conflict"] = 409] = "Conflict";
    HTTPCodes[HTTPCodes["Gone"] = 410] = "Gone";
    HTTPCodes[HTTPCodes["LengthRequired"] = 411] = "LengthRequired";
    HTTPCodes[HTTPCodes["PreconditionFailed"] = 412] = "PreconditionFailed";
    HTTPCodes[HTTPCodes["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    HTTPCodes[HTTPCodes["URITooLong"] = 414] = "URITooLong";
    HTTPCodes[HTTPCodes["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HTTPCodes[HTTPCodes["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    HTTPCodes[HTTPCodes["ExpectationFailed"] = 417] = "ExpectationFailed";
    HTTPCodes[HTTPCodes["ImATeapot"] = 418] = "ImATeapot";
    HTTPCodes[HTTPCodes["AuthenticationTimeout"] = 419] = "AuthenticationTimeout";
    HTTPCodes[HTTPCodes["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HTTPCodes[HTTPCodes["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HTTPCodes[HTTPCodes["Locked"] = 423] = "Locked";
    HTTPCodes[HTTPCodes["FailedDependency"] = 424] = "FailedDependency";
    HTTPCodes[HTTPCodes["TooEarly"] = 425] = "TooEarly";
    HTTPCodes[HTTPCodes["UpgradeRequired"] = 426] = "UpgradeRequired";
    HTTPCodes[HTTPCodes["PreconditionRequired"] = 428] = "PreconditionRequired";
    HTTPCodes[HTTPCodes["TooManyRequests"] = 429] = "TooManyRequests";
    HTTPCodes[HTTPCodes["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HTTPCodes[HTTPCodes["RetryWith"] = 449] = "RetryWith";
    HTTPCodes[HTTPCodes["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HTTPCodes[HTTPCodes["ClientClosedRequest"] = 499] = "ClientClosedRequest";
    HTTPCodes[HTTPCodes["ServerInternalError"] = 500] = "ServerInternalError";
    HTTPCodes[HTTPCodes["NotImplemented"] = 501] = "NotImplemented";
    HTTPCodes[HTTPCodes["BadGateway"] = 502] = "BadGateway";
    HTTPCodes[HTTPCodes["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HTTPCodes[HTTPCodes["GatewayTimeout"] = 504] = "GatewayTimeout";
    HTTPCodes[HTTPCodes["HTTPVersionNotSupported"] = 505] = "HTTPVersionNotSupported";
    HTTPCodes[HTTPCodes["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HTTPCodes[HTTPCodes["InsufficientStorage"] = 507] = "InsufficientStorage";
    HTTPCodes[HTTPCodes["LoopDetected"] = 508] = "LoopDetected";
    HTTPCodes[HTTPCodes["BandwidthLimitExceeded"] = 509] = "BandwidthLimitExceeded";
    HTTPCodes[HTTPCodes["NotExtended"] = 510] = "NotExtended";
    HTTPCodes[HTTPCodes["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
    HTTPCodes[HTTPCodes["UnknownError"] = 520] = "UnknownError";
    HTTPCodes[HTTPCodes["WebServerIsDown"] = 521] = "WebServerIsDown";
    HTTPCodes[HTTPCodes["ConnectionTimedOut"] = 522] = "ConnectionTimedOut";
    HTTPCodes[HTTPCodes["OriginIsUnreachable"] = 523] = "OriginIsUnreachable";
    HTTPCodes[HTTPCodes["ATimeoutOccurred"] = 524] = "ATimeoutOccurred";
    HTTPCodes[HTTPCodes["SSLHandshakeFailed"] = 525] = "SSLHandshakeFailed";
    HTTPCodes[HTTPCodes["InvalidSSLCertificate"] = 526] = "InvalidSSLCertificate";
    //IternalErrors
    HTTPCodes[HTTPCodes["UnknownResponse"] = 1000] = "UnknownResponse";
    HTTPCodes[HTTPCodes["BadDataFormat"] = 1001] = "BadDataFormat";
})(HTTPCodes = exports.HTTPCodes || (exports.HTTPCodes = {}));
;
var MIMEs;
(function (MIMEs) {
    MIMEs["AppJson"] = "application/json";
    MIMEs["AppJsonUTF8"] = "application/json;charset=utf-8";
    MIMEs["MultiPartFormData"] = "multipart/form-data";
    MIMEs["ImageGIF"] = "image/gif";
    MIMEs["ImageJPEG"] = "image/jpeg";
    MIMEs["ImagePNG"] = "image/png";
    MIMEs["ImageWebP"] = "image/webp";
    MIMEs["TextHTML"] = "text/html";
    MIMEs["TextCSS"] = "text/css";
})(MIMEs = exports.MIMEs || (exports.MIMEs = {}));
;
function isInEnum(type, enumObj) { return Object.values(type).includes(enumObj); }
function isHTTPMethod(value) { return isInEnum(HTTPMethods, value.toUpperCase()); }
exports.isHTTPMethod = isHTTPMethod;
function isHTTPCode(value) { return isInEnum(HTTPCodes, value); }
exports.isHTTPCode = isHTTPCode;
function isMIME(value) { return isInEnum(MIMEs, value); }
exports.isMIME = isMIME;
//# sourceMappingURL=Enums.js.map